import Service from "./Service";

export default class AdditionalPayment extends Service {
    constructor() {
        super();
    }

    refund(data) {
        return this.axios.post('/refund', data);
    }
}